import { render, staticRenderFns } from "./VariableCheckBox.vue?vue&type=template&id=512867d3&"
import script from "./VariableCheckBox.vue?vue&type=script&lang=ts&"
export * from "./VariableCheckBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports